import { SubstitutionConditionDto } from ".";

export class TacticChangeDto {
    tactic: number;
	
	minute: SubstitutionConditionDto;
	
	score: SubstitutionConditionDto;
	
	isChangePosition: boolean;
	
	isChangeSettings: boolean;
}